export function cleanDocument(cpfOrCnpj?: string | null): string {
  return cpfOrCnpj !== undefined && cpfOrCnpj !== null
    ? cpfOrCnpj.replace(/[^a-z0-9]/gi, '').toUpperCase()
    : '';
}
